export default {
  methods: {
    in() {
      this.tl.restart()
    },
  },
}
